import { Grid, Fab } from "@material-ui/core";
import React, { FC } from "react";
import {
  RiFacebookFill,
  RiInstagramLine,
  RiPinterestFill,
  RiTwitterFill,
  RiLinkedinBoxFill,
  RiLineFill,
  RiRedditFill,
  RiSkypeFill,
  RiSnapchatFill,
  RiTwitchFill,
  RiYoutubeFill,
  RiTelegramFill,
} from "react-icons/ri";
import { FaViber } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import { SocialNetworks } from "store/url-builder";
import { SocialProvider, NewSocialProvider } from "..";
import style from "./social-list.module.scss";
import X from "../X";

export const getSocialIcon = (
  provider: SocialProvider | NewSocialProvider,
  { width, height }: { width: number; height: number }
) => {
  switch (provider) {
    case SocialProvider.FACEBOOK:
      return <RiFacebookFill style={{ width, height }} color="#4267B2" />;
    case SocialProvider.INSTAGRAM:
      return <RiInstagramLine style={{ width, height }} color="#E1306C" />;
    case SocialProvider.PINTEREST:
      return <RiPinterestFill style={{ width, height }} color="#E60023" />;
    case SocialProvider.TWITTER:
      return <X style={{ width: "20px", height: "20px" }} color="#1DA1F2" />;
    case SocialProvider.LINKEDIN:
      return <RiLinkedinBoxFill style={{ width, height }} color="#0e76a8" />;
    case NewSocialProvider.LINKEDIN:
      return <RiLinkedinBoxFill style={{ width, height }} color="#0e76a8" />;
    case SocialProvider.YOUTUBE:
      return <RiYoutubeFill style={{ width, height }} color="#FF0000" />;
    case SocialProvider.SNAPCHAT:
      return <RiSnapchatFill style={{ width, height }} color="#FFFC00" />;
    case SocialProvider.SKYPE:
      return <RiSkypeFill style={{ width, height }} color="#00aff0" />;
    case NewSocialProvider.SKYPE_ID:
      return <RiSkypeFill style={{ width, height }} color="#00aff0" />;
    case SocialProvider.REDDIT:
      return <RiRedditFill style={{ width, height }} color="#FF4500" />;
    case SocialProvider.LINE:
      return <RiLineFill style={{ width, height }} color="#00B900" />;
    case SocialProvider.TWITCH:
      return <RiTwitchFill style={{ width, height }} color="#6441A4" />;
    case SocialProvider.TELEGRAM:
      return <RiTelegramFill style={{ width, height }} color="#0088CC" />;
    case SocialProvider.VIBER:
      return <FaViber style={{ width, height }} color="#665CAC" />;
    case SocialProvider.TIKTOK:
      return <SiTiktok style={{ width, height }} color="#010101" />;
  }
};

export interface SocialNetworkListProps {
  socialNetworks: SocialNetworks[];
  onItemClick?(item: SocialNetworks): void;
}

export const SocialNetworkList: FC<SocialNetworkListProps> = ({
  socialNetworks,
  onItemClick,
}) => {
  return (
    <Grid container spacing={1}>
      {socialNetworks.map((social) => {
        if (social.networkName.length === 0) return "";
        return (
          <Grid item key={social.networkName}>
            <Fab
              className={style.socialItem}
              onClick={() => onItemClick && onItemClick(social)}
              aria-label="add"
            >
              {getSocialIcon(
                social.networkName as SocialProvider | NewSocialProvider,
                { width: 30, height: 30 }
              )}
            </Fab>
          </Grid>
        );
      })}
    </Grid>
  );
};
